import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { Btn, Heading, P, SectionWrapper } from '../../Styles/style'
import styled from '@emotion/styled'
import colorbg from '../../../assets/colorbg.png'
import Decent from '../../../assets/decent.png'
import Buy from '../../../assets/buy.png'
import Market from '../../../assets/market.png'
import Lock from '../../../assets/lock.png'
import Fair from '../../../assets/fair.png'

const WhyWrapper = styled.div`
padding: 12rem 0;
background-image: url(${colorbg});
min-height: 100vh;
background-size: cover;
display: flex;
    align-items: center;
`
const SectionHeading = styled.div`
font-size: 50px;
font-family: "Poppins-Bold";
padding: 30px 0;
`
const SectionSubHeading = styled.div`
font-size: 30px;
color: #BA51FF;
  font-family: "Poppins-SemiBold";
  max-width: 60%;
`
const SocialMediaDiv = styled.div`
display:flex;
`
const FactsWrapper = styled.div`
border: 1px solid #000;
padding:30px;
border-radius: 10px;
min-height:300px ;
`
const FactSmallimg = styled.img`
width: 100%;
height: auto;
max-width: 40px;
`
const FactHeading = styled.div`
display: flex;
font-size:24px ;
padding-left: 10px;
font-family: "Poppins-Bold";
`
const Protocol = () => {
  return (
    <div>
       <SectionWrapper>
        <Container maxWidth="xl">
          
        <SectionHeading>Facts
            </SectionHeading>
          <Grid container rowSpacing={4} columnSpacing={8} style={{placeContent:'center'}}>
          <Grid item xs={12} md={4}>
     <FactsWrapper>
      <FactHeading>
      <FactSmallimg src={Fair} />&nbsp;Fair Launch
      </FactHeading>
      <P m="20px 0 0">Sanshu Inu will be 100% fairlaunched which no no pre-mining, which means that no coins or tokens are created or distributed before the launch. 
</P>

     </FactsWrapper>
           
          </Grid>
          <Grid item xs={12} md={4}>
     <FactsWrapper>
      <FactHeading>
      <FactSmallimg src={Lock} />&nbsp;No Rug Possible
      </FactHeading>
      <P m="20px 0 0">Sanshu Inu is a 100% community token, thus it’ll be renounced post launch to ensure the token is safe and 100% unruggable
</P>

     </FactsWrapper>
           
          </Grid>
          <Grid item xs={12} md={4}>
     <FactsWrapper>
      <FactHeading>
      <FactSmallimg src={Market} />&nbsp;Market and Adoption
      </FactHeading>
      <P m="20px 0 0">Sanshu Inu aims to gain mass adoption by building a strong and dedicated community of users through social media and other platforms.
</P>

     </FactsWrapper>
           
          </Grid>
          <Grid item xs={12} md={4}>
     <FactsWrapper>
      <FactHeading>
      <FactSmallimg src={Decent} />&nbsp;100% Decentralized
      </FactHeading>
      <P m="20px 0 0">Sanshu Inu is truly 100% decentralized which means that it is not controlled by any central authority or organization. It’s literally incorruptible and designed to be a robust, fairly distributed community driven token.
</P>

     </FactsWrapper>
           
          </Grid>
          <Grid item xs={12} md={4}>
     <FactsWrapper>
      <FactHeading>
      <FactSmallimg src={Buy} />&nbsp;DISTRUBTION REWARDS
      </FactHeading>
      <P m="20px 0 0">Holders will receive distribution rewards of Shiba Ainu tokens in their wallets every time someone buys and sells Sanshu tokens. It’s like making money while you sleep!</P>

     </FactsWrapper>
           
          </Grid>
          <Grid item xs={12} md={6} style={{textAlign: 'end', padding: '3.5rem 0'}}>
          </Grid>
          </Grid>
        </Container>
        </SectionWrapper>
    </div>
  )
}

export default Protocol